import React from "react";

function CameraFlipIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.444"
      height="22"
      viewBox="0 0 24.444 22"
    >
      <path
        id="Flip_Icon"
        data-name="Flip Icon"
        d="M11.568,5.444,9.124,7.889H4.444V22.556H24V7.889H19.321L16.876,5.444ZM10.556,3h7.333l2.444,2.444h4.889a1.222,1.222,0,0,1,1.222,1.222V23.778A1.222,1.222,0,0,1,25.222,25h-22A1.222,1.222,0,0,1,2,23.778V6.667A1.222,1.222,0,0,1,3.222,5.444H8.111Zm.783,5.537a6.723,6.723,0,0,1,7.562,10.9l-2.539-4.705H18.5c0-.041,0-.081,0-.122A4.28,4.28,0,0,0,12.476,10.7Zm5.716,12.172A6.723,6.723,0,0,1,9.5,9.826l2.582,4.785H9.944a4.28,4.28,0,0,0,5.971,3.929Z"
        transform="translate(-2 -3)"
        fill="#fff"
      />
    </svg>
  );
}

export default CameraFlipIcon;
